export default __webpack_public_path__ + "images/2623e306a65a4927c9e025d18552465e.svg";